// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__mDLZJ","content":"RecentSearches_content__19wl2"};